// extracted by mini-css-extract-plugin
export default {"TextLinkButton":"TextLinkButton_TextLinkButton__cmtHh"};